<template>
  <div>
    <!-- pc -->
    <div
      class="foot_pc"
      :class="[
        currentPathname === '/productSeries' ? 'addTopPd4' : '',
        currentPathname === '/blog' ? 'addTopPd5' : '',
      ]"
    >
      <div class="topPart">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/logo.png"
          alt=""
          class="logoPic"
        />
        <div class="centerInfoPart">
          <div class="roomAddrPart">
            <div class="addrTitle">办公地址</div>
            <div class="addrItem">纽约</div>
            <div class="addrItem">成都</div>
          </div>
          <div class="focusUsPart">
            <div class="focusTitle">关注我们</div>
            <div class="ourPlatformPics">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/hongshu.png"
                alt=""
                class="platPic cursor"
                @click="gof(1)"
              />
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/weibo_icon.png"
                alt=""
                class="platPic cursor"
                @click="gof(3)"
              />
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/wx_icon.png"
                alt=""
                class="platPic cursor"
                @click="toGongzhonghao"
              />
            </div>
          </div>
          <div class="connectUsPart">
            <div class="connectTitle">联系我们</div>
            <div class="connectItem">028-85211401</div>
            <div class="connectItem">info@nutri-packs.com</div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/yys_code.png"
          alt=""
          class="codePic"
        />
      </div>

      <div class="line"></div>

      <div class="botBox">
        <div class="beianBox">
          <div class="copyright">
            Copyright © 2019 - {{ currentYear }} NUTRIPACKS 橘袋
          </div>
          <div class="beianNo">
            All Rights Reserved｜<span class="cursor" @click="beian"
              >蜀ICP备18038614号-2</span
            >
          </div>
          <a
            target="_blank"
            class="beianGa"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51012202000914"
            ><img src="../../public/imgs/badges.png" class="gonganPic" />
            <p>川公网安备 51012202000914号</p></a
          >
        </div>
        <div class="englishBox">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure
          or prevent any disease.
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div
      class="foot_m"
      :class="[
        currentPathname === '/make_nutrition' ? 'addTopPd1' : '',
        currentPathname === '/aboutUs' ? 'addTopPd2' : '',
        currentPathname === '/quality' ? 'addTopPd3' : '',
        currentPathname === '/productSeries' ? 'addTopPd4' : '',
        currentPathname === '/blog' ? 'addTopPd6' :currentPathname === '/index' ? 'addTopPd8': 'addTopPd7',
      ]"
    >
      <div class="topPart">
        <div class="leftPart">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/logo.png"
            alt=""
            class="logoPic"
          />
          <div class="centerInfoPart">
            <div class="roomAddrPart">
              <div class="addrTitle">办公地址</div>
              <div class="addrItem">纽约</div>
              <div class="addrItem">成都</div>
            </div>
            <div class="focusUsPart">
              <div class="focusTitle">关注我们</div>
              <div class="ourPlatformPics">
                <img
                  src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/hongshu.png"
                  alt=""
                  class="platPic cursor"
                  @click="gof(1)"
                />
                <img
                  src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/weibo_icon.png"
                  alt=""
                  class="platPic cursor"
                  @click="gof(3)"
                />
                <img
                  src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/wx_icon.png"
                  alt=""
                  class="platPic cursor"
                  @click="toGongzhonghao"
                />
              </div>
            </div>
            <div class="connectUsPart">
              <div class="connectTitle">联系我们</div>
              <div class="connectItem">028-85211401</div>
              <div class="connectItem">info@nutri-packs.com</div>
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/imgs/foot/yys_code.png"
          alt=""
          class="codePic"
        />
      </div>

      <div class="botBox">
        <div class="englishBox">
          These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure
          or prevent any disease.
        </div>
        <div class="beianBox">
          <!-- <div class="copyright">Copyright © 2019 - 2025 NUTRIPACKS 橘袋</div> -->
          <div class="copyright">
            Copyright © 2019 - {{ currentYear }} NUTRIPACKS 橘袋
          </div>
          <div class="beianNo">
            All Rights Reserved｜<span class="cursor" @click="beian"
              >蜀ICP备18038614号-2</span
            >
          </div>
          <a
            target="_blank"
            class="beianGa"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51012202000914"
            ><img src="../../public/imgs/badges.png" class="gonganPic" />
            <p>川公网安备 51012202000914号</p></a
          >
        </div>
      </div>
    </div>

    <!-- 定制弹窗 -->
    <weixinPupop ref="myPupop" :left="left" :top="top"></weixinPupop>
  </div>
</template>

<script>
import checkIsInApp from "../util/app.js";
import weixinPupop from "./weixinPupop.vue";

export default {
  name: "foot",
  components: {
    weixinPupop,
  },
  data: () => ({
    isScroll: false,
    shanghaishow: false,
    isbserve: 0,
    isAlipay: navigator.userAgent.indexOf("AliApp") > -1 ? true : false,
    currentPathname: "",
    left: 0,
    top: 0,
    currentYear: "2025",
  }),
  mounted() {
    let timer = null;
    this.shanghaishow = sessionStorage.getItem("shanghaishow");
    this.isbserve = sessionStorage.getItem("is_b_serve");
    this.showAI = sessionStorage.getItem("showAI") * 1;
    window.addEventListener("scroll", () => {
      clearTimeout(timer);
      this.isScroll = true;

      timer = setTimeout(() => {
        this.isScroll = false;
      }, 300);
    });
    this.currentYear = new Date().getFullYear();
  },
  created() {
    this.showAI = sessionStorage.getItem("showAI") * 1;
  },
  watch: {
    $route: {
      handler(to) {
        this.fullPath = to.fullPath;
        // 根据url页面路径决定该展示footer的哪种背景色
        this.currentPathname = window.location.pathname;
      },
      immediate: true,
    },
  },
  methods: {
    toGongzhonghao(event) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;
      console.log("this.$refs.myPupop.showPupop()----", this.left, this.top);
      this.$refs.myPupop.showPupop();
    },
    checkIsInApp() {
      return checkIsInApp();
    },
    beian() {
      window.open("https://beian.miit.gov.cn/");
    },
    gokefu() {
      this.$router.push({
        path: "service",
      });
    },
    godingzhi() {
      this.$router.push({
        path: "home",
      });
    },
    godingzhi2() {
      this.$router.push({
        path: "home",
      });
      this.showAI = false;
      sessionStorage.setItem("showAI", 0);
    },
    goBackIndex() {
      this.$router.push({
        path: "/",
      });
      this.showAI = false;
      sessionStorage.setItem("showAI", 0);
    },
    gof(e) {
      if (e == 1) {
        window.open(
          "https://www.xiaohongshu.com/user/profile/5dba88790000000001002ee0"
        );
      } else if (e == 2) {
        window.open("https://www.instagram.com/nutripacks_official/");
      } else if (e == 3) {
        window.open(
          "https://weibo.com/p/1006065832297643/home?from=page_100606&mod=TAB"
        );
      } else if (e == 4) {
        window.open("https://twitter.com/nutripackschina");
      } else if (e == 5) {
        window.open("https://www.facebook.com/nutripackspage");
      } else if (e == 6) {
        window.location.href = "mailto:zhangfei@nutri-packs.com";
      } else if (e == 7) {
        window.location.href = "tel:028-85211401";
      } else if (e == 8) {
        // window.open('https://goo.gl/maps/MmqAukTguKWbN27F7')
      } else if (e == 9) {
        // window.open('https://goo.gl/maps/WaZAE74awGYP3FZbA')
      }
    },
  },
};
</script>

<style scoped>
/* /make_nutrition  footer背景色 */
@media screen and (max-width: 767px) {
  .addTopPd1 {
    padding-top: 0.9259rem !important;
  }
  .addTopPd2 {
    padding-top: 1.5rem !important;
  }
  .addTopPd3 {
    padding-top: 1.5rem !important;
  }
  .addTopPd4 {
    padding-top: 1.5rem !important;
  }
  .addTopPd5 {
    padding-top: 1.5rem !important;
  }
  .addTopPd6 {
    padding-top: 1.5rem !important;
  }
  /* 首页 */
  .addTopPd8 {
    padding-top: 1.26rem !important;
  }
  /* 其他 */
  .addTopPd7 {
    padding-top: 1.5rem !important;
  }
  
}
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .addTopPd1 {
    padding-top: 1.8519rem !important;
  }
  .addTopPd2 {
    padding-top: 1.85rem !important;
  }
  .addTopPd3 {
    padding-top: 1.85rem !important;
  }
  .addTopPd4 {
    padding-top: 2.22rem !important;
  }
  .addTopPd5 {
    padding-top: 2.22rem !important;
  }
  .addTopPd6 {
    padding-top: 2.22rem !important;
  }
  /* 首页 */
  .addTopPd8 {
    padding-top: 1.85rem !important;
  }
  /* 其他 */
  .addTopPd7 {
    padding-top: 1.85rem !important;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .addTopPd4 {
    padding-top: 2.22rem !important;
  }
  .addTopPd5 {
    padding-top: 2.22rem !important;
  }
  .addTopPd6 {
    padding-top: 2.22rem !important;
  }
}
@media screen and (min-width: 1920px) {
  .addTopPd4 {
    padding-top: 2.22rem !important;
  }
  .addTopPd5 {
    padding-top: 2.22rem !important;
  }
}
.hide-fixed-service-buttom {
  transform: translateX(100px);
}
</style>

<style lang="scss" scoped>
.cursor {
  cursor: pointer;
}
//mobile414
@media screen and (max-width: 767px) {
  .foot_pc {
    display: none !important;
  }
  .foot_m {
    padding: 0 0.4348rem;
    padding-bottom: 1.2077rem;

    .topPart {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .leftPart {
        display: flex;
        flex-direction: column;
        .logoPic {
          width: 3.3092rem;
          height: 0.628rem;
        }
        .centerInfoPart {
          display: flex;
          margin-top: 0.8696rem;

          .roomAddrPart {
            min-width: 1.256rem;
            .addrTitle {
              font-weight: 600;
              font-size: 0.314rem;
              color: #141414;
              line-height: 0.4831rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;
              margin-bottom: 0.314rem;
            }
            .addrTitle::after {
              width: 1.3043rem;
              height: 0.0483rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4348rem;
              content: "";
            }
            .addrItem {
              font-weight: 400;
              font-size: 0.2657rem;
              color: #141414;
              line-height: 0.4831rem;
              text-align: left;
              font-style: normal;
            }
            .addrItem:last-child {
              margin-top: 0px;
            }
          }
          .focusUsPart {
            margin-left: 0.6039rem;
            min-width: 1.256rem;

            .focusTitle {
              font-weight: 600;
              font-size: 0.314rem;
              color: #141414;
              line-height: 0.4831rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;
              margin-bottom: 0.314rem;
            }
            .focusTitle::after {
              width: 1.3043rem;
              height: 0.0483rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4348rem;
              content: "";
            }
            .ourPlatformPics {
              display: flex;
              align-items: start;
              .platPic {
                width: 0.3623rem;
                height: 0.3623rem;
                margin-right: 0.0725rem;
              }
              .platPic:last-child {
                margin-right: 0;
              }
            }
          }
          .connectUsPart {
            margin-left: 1.0145rem;
            min-width: 1.256rem;

            .connectTitle {
              font-weight: 600;
              font-size: 0.314rem;
              color: #141414;
              line-height: 0.4831rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;
              margin-bottom: 0.314rem;
            }
            .connectTitle::after {
              width: 1.3043rem;
              height: 0.0483rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4348rem;
              content: "";
            }
            .connectItem {
              font-weight: 400;
              font-size: 0.2657rem;
              color: #141414;
              line-height: 0.4831rem;
              text-align: left;
              font-style: normal;
            }
            .connectItem:last-child {
              margin-top: 0px;
            }
          }
        }
      }

      .codePic {
        width: 1.7391rem;
        height: 2.1498rem;
      }
    }

    .botBox {
      margin-top: 0.4348rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .englishBox {
        font-weight: 400;
        font-size: 0.2174rem;
        color: #666666;
        line-height: 0.314rem;
        text-align: left;
        font-style: normal;
        width: 100%;

        padding: 0.0966rem 0.2415rem 0.1449rem 0.2415rem;
        border: 0.0242rem solid #979797;
      }
      .beianBox {
        font-weight: 400;
        font-size: 0.2415rem;
        color: #141414;
        line-height: 0.3623rem;
        text-align: right;
        font-style: normal;
        text-transform: uppercase;
        margin-top: 0.4348rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .beianGa {
          margin-top: 0.1691rem;
          display: flex;
          align-items: center;
          text-decoration: none;
          .gonganPic {
            width: 0.3865rem;
            height: 0.3865rem;
            margin-right: 0.2174rem;
          }
          p {
            font-weight: 400;
            font-size: 0.2415rem;
            color: #141414;
            line-height: 0.4589rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;

            display: inline-block;
          }
        }
      }
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .foot_pc {
    display: none !important;
  }
  .foot_m {
    padding: 0 0.8148rem;
    padding-bottom: 0.9259rem;

    .topPart {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .leftPart {
        display: flex;
        flex-direction: column;
        .logoPic {
          width: 4.3148rem;
          height: 0.8148rem;
        }
        .centerInfoPart {
          display: flex;
          margin-top: 1.2963rem;

          .roomAddrPart {
            min-width: 1.4815rem;

            .addrTitle {
              font-weight: 600;
              font-size: 0.3704rem;
              color: #141414;
              line-height: 0.3704rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;

              margin-bottom: 0.7778rem;
            }
            .addrTitle::after {
              width: 1.4815rem;
              height: 0.0741rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4074rem;
              content: "";
            }
            .addrItem {
              font-weight: 400;
              font-size: 0.2963rem;
              color: #141414;
              line-height: 0.3704rem;
              text-align: left;
              font-style: normal;
            }
            .addrItem:last-child {
              margin-top: 0.3704rem;
            }
          }
          .focusUsPart {
            margin-left: 1.0185rem;
            min-width: 2.037rem;

            .focusTitle {
              font-weight: 600;
              font-size: 0.3704rem;
              color: #141414;
              line-height: 0.3704rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;

              margin-bottom: 0.7778rem;
            }
            .focusTitle::after {
              width: 1.4815rem;
              height: 0.0741rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4074rem;
              content: "";
            }
            .ourPlatformPics {
              display: flex;
              align-items: start;
              .platPic {
                width: 0.4815rem;
                height: 0.4815rem;
                margin-right: 0.2963rem;
              }
              .platPic:last-child {
                margin-right: 0;
              }
            }
          }
          .connectUsPart {
            margin-left: 1.5185rem;
            min-width: 1.4815rem;

            .connectTitle {
              font-weight: 600;
              font-size: 0.3704rem;
              color: #141414;
              line-height: 0.3704rem;
              text-align: left;
              font-style: normal;
              text-transform: uppercase;
              position: relative;

              margin-bottom: 0.7778rem;
            }
            .connectTitle::after {
              width: 1.4815rem;
              height: 0.0741rem;
              background: #c25e4d;
              position: absolute;
              left: 0;
              top: 0.4074rem;
              content: "";
            }
            .connectItem {
              font-weight: 400;
              font-size: 0.2963rem;
              color: #141414;
              line-height: 0.3704rem;
              text-align: left;
              font-style: normal;
            }
            .connectItem:last-child {
              margin-top: 0.3704rem;
            }
          }
        }
      }

      .codePic {
        width: 2.4074rem;
        height: 2.9259rem;
      }
    }

    .botBox {
      margin-top: 0.7407rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .englishBox {
        font-weight: 400;
        font-size: 0.2593rem;
        color: #666666;
        line-height: 0.3704rem;
        text-align: left;
        font-style: normal;
        width: 100%;

        padding: 0.2778rem 1.2222rem 0.2778rem 1.4444rem;
        border: 0.0185rem solid #979797;
      }
      .beianBox {
        font-weight: 400;
        font-size: 0.2963rem;
        color: #141414;
        line-height: 0.4074rem;
        text-align: right;
        font-style: normal;
        text-transform: uppercase;
        margin-top: 0.7407rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .beianGa {
          margin-top: 0.1667rem;
          display: flex;
          align-items: center;
          text-decoration: none;
          .gonganPic {
            width: 0.4074rem;
            height: 0.4074rem;
            margin-right: 0.1667rem;
          }
          p {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3519rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;

            display: inline-block;
          }
        }
      }
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .foot_m {
    display: none !important;
  }
  .foot_pc {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 0 102px;
    width: 22.8889rem;
    margin-left: 50%;
    transform: translateX(-50%);
    padding-bottom: 0.9259rem;

    .topPart {
      display: flex;
      justify-content: space-between;
      width: 100%;
      // min-width: 1400px;

      .logoPic {
        width: 4.3148rem;
        height: 0.8148rem;
      }
      .centerInfoPart {
        display: flex;

        .roomAddrPart {
          min-width: 1.4815rem;
          .addrTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .addrTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .addrItem {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
          }
          .addrItem:last-child {
            margin-top: 0.3704rem;
          }
        }
        .focusUsPart {
          margin-left: 1.8889rem;
          min-width: 2.037rem;

          .focusTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .focusTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .ourPlatformPics {
            display: flex;
            align-items: start;
            .platPic {
              width: 0.4815rem;
              height: 0.4815rem;
              margin-right: 0.2963rem;
            }
            .platPic:last-child {
              margin-right: 0;
            }
          }
        }
        .connectUsPart {
          margin-left: 1.8889rem;
          min-width: 1.4815rem;
          .connectTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .connectTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .connectItem {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
          }
          .connectItem:last-child {
            margin-top: 0.3704rem;
          }
        }
      }
      .codePic {
        width: 2.4074rem;
        height: 2.9259rem;
      }
    }

    .line {
      height: 0.037rem;
      background: #000000;
      margin-top: 1.0185rem;
      width: 100%;
    }
    .botBox {
      display: flex;
      align-items: start;
      justify-content: space-between;
      margin-top: 0.7778rem;
      width: 100%;
      .beianBox {
        font-weight: 400;
        font-size: 0.2963rem;
        color: #141414;
        line-height: 0.4074rem;
        text-align: left;
        font-style: normal;
        text-transform: uppercase;
        .beianGa {
          margin-top: 0.1481rem;
          display: flex;
          align-items: center;
          text-decoration: none;
          .gonganPic {
            width: 0.4074rem;
            height: 0.4074rem;
            margin-right: 0.1667rem;
          }
          p {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3519rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            display: inline-block;
          }
        }
      }
      .englishBox {
        width: 11.0185rem;
        min-height: 1.2963rem;
        border: 0.0185rem solid #979797;
        font-weight: 400;
        font-size: 0.2593rem;
        color: #666666;
        line-height: 0.3704rem;
        text-align: left;
        font-style: normal;

        padding: 0.2778rem 0.4259rem 0.2778rem 0.6667rem;
      }
    }
  }
}
//大web1920
@media screen and (min-width: 1920px) {
  .foot_m {
    display: none !important;
  }
  .foot_pc {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 0 260px;
    width: 25.9259rem;
    margin-left: 50%;
    transform: translateX(-50%);
    padding-bottom: 0.9259rem;

    .topPart {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .logoPic {
        width: 4.3333rem;
        height: 0.8333rem;
      }
      .centerInfoPart {
        display: flex;

        .roomAddrPart {
          min-width: 1.4815rem;
          .addrTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .addrTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .addrItem {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
          }
          .addrItem:last-child {
            margin-top: 0.3704rem;
          }
        }
        .focusUsPart {
          margin-left: 2.2222rem;
          min-width: 2.037rem;
          .focusTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .focusTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .ourPlatformPics {
            display: flex;
            align-items: start;
            .platPic {
              width: 0.4815rem;
              height: 0.4815rem;
              margin-right: 0.2963rem;
            }
            .platPic:last-child {
              margin-right: 0;
            }
          }
        }
        .connectUsPart {
          margin-left: 2.2222rem;
          .connectTitle {
            font-weight: 600;
            font-size: 0.3704rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            position: relative;
            margin-bottom: 0.7778rem;
          }
          .connectTitle::after {
            width: 1.4815rem;
            height: 0.0741rem;
            background: #c25e4d;
            position: absolute;
            left: 0;
            top: 0.463rem;
            content: "";
          }
          .connectItem {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3704rem;
            text-align: left;
            font-style: normal;
          }
          .connectItem:last-child {
            margin-top: 0.3704rem;
          }
        }
      }
      .codePic {
        width: 2.4444rem;
        height: 2.963rem;
      }
    }

    .line {
      height: 0.037rem;
      background: #000000;
      margin-top: 0.9815rem;
      width: 100%;
      // min-width: 1400px;
    }
    .botBox {
      display: flex;
      align-items: start;
      justify-content: space-between;
      margin-top: 0.7963rem;
      width: 100%;
      // min-width: 1400px;
      .beianBox {
        font-weight: 400;
        font-size: 0.2963rem;
        color: #141414;
        line-height: 0.4074rem;
        text-align: left;
        font-style: normal;
        text-transform: uppercase;
        .beianGa {
          margin-top: 0.1481rem;
          display: flex;
          align-items: center;
          text-decoration: none;
          .gonganPic {
            width: 0.4074rem;
            height: 0.4074rem;
            margin-right: 0.1667rem;
          }
          p {
            font-weight: 400;
            font-size: 0.2963rem;
            color: #141414;
            line-height: 0.3519rem;
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
            display: inline-block;
          }
        }
      }
      .englishBox {
        width: 11.0185rem;
        min-height: 1.2963rem;
        border: 0.0185rem solid #979797;
        font-weight: 400;
        font-size: 0.2593rem;
        color: #666666;
        line-height: 0.3704rem;
        text-align: left;
        font-style: normal;

        padding: 0.2778rem 0.4259rem 0.2778rem 0.6667rem;
      }
    }
  }
}
</style>
